import React, {memo, Suspense} from 'react';
import config from '../../service/config';
import {ToastContainer, Slide} from 'react-toastify';
import Header from '../header/Header';
import HeaderPlaceholder from '../header/HeaderPlaceholder';
import {PageWrapper} from '../util/StyledElements';
import SettingsView from './SettingsView';
import {useTscTheme} from '../../context/themeProvider';
import styled from 'styled-components';

const SettingsContentWrapper = styled.div`
   display: flex;
   flex-direction: row;
   width: 100%;
`;

export const SettingsBase: React.FC = () => {
   const theme = useTscTheme();

   return (
      <PageWrapper
         id="modal-root"
         theme={theme}
      >
         <ToastContainer
            position="top-center"
            transition={Slide}
         />
         <Suspense fallback={<HeaderPlaceholder />}>
            <Header
               hideSearch={config.featureSwitches.DisableSearch}
               hideEntitlementInfo={false}
               hideThemePicker={false}
               hideNavLinkTabs={false}
            />
         </Suspense>
         <SettingsContentWrapper>
            <SettingsView />
         </SettingsContentWrapper>
      </PageWrapper>
   );
};

export default memo(SettingsBase);
